export default __webpack_public_path__ + "static/media/MeasureIllustration.b5448559.svg";